module.exports = require("/Users/cameronmconie/Dev/blockv/web/developer-platform/src/utils/typography.js")


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = 1137
// module chunks = 231608221292675